<template>
	<div class="document-home">
		<div class="document-header">
			<div class="document-header-logo">
				{{page.title}}
			</div>
			<div class="document-header-version">
				<link-select :width="80" :data="versionList" labelKey="version" valKey="id" v-model="curVersion" type="none" hideClearIcon/>
			</div>
			<div class="document-header-search">
				<link-select suffixIcon="icon-search" placeholder="搜索文档..." :data="searchRecommend" labelKey="title" valKey="id" v-model="searchMenuId" @select="searchChange" :width="300"/>
			</div>

			<div class="document-header-user">
				<link-dropdown align="end" :height="null" width="120" v-model="showDropdown" class="document-link-list">
					<template slot="reference">
						<span>其他文档</span>
						<link-icon :icon="showDropdown?'icon-triangle-up1':'icon-triangle-down1'"/>
					</template>
					<div slot="popover">
						<link-dropdown-item v-for="item in documentLinks" :label="item.label" :key="item.label" @click="openDocument(item)"/>
					</div>
				</link-dropdown>

				<link-icon icon="icon-user-circle"/>
				<template v-if="!!fstname">
					<!--<span>{{fstname}}</span>
					<span class="document-header-user-logout-btn" @click="logout">退出</span>-->
					<link-dropdown align="end" :height="null" width="120" v-model="showUserDropdown" class="document-link-list">
						<template slot="reference">
							<span>{{fstname}}</span>
							<link-icon :icon="showUserDropdown?'icon-triangle-up1':'icon-triangle-down1'"/>
						</template>
						<div slot="popover">
							<link-dropdown-item label="访问统计" @click="openDocStaticstics('access')"/>
							<link-dropdown-item label="创作统计" @click="openDocStaticstics('creation')"/>
							<link-dropdown-item label="我的文档" @click="openDocStaticstics('my-menu')"/>
							<link-dropdown-item label="退出登录" @click="logout"/>
						</div>
					</link-dropdown>
				</template>
				<template v-else>
					<span class="document-header-user-login-btn" @click="login">登录</span>
				</template>
			</div>
		</div>

		<div class="document-body">
			<document-menu ref="menu" :menus="page.MENUS" @click="openMenu" :curMenu="curMenu" showMenuIndex/>
			<div class="document-content" v-if="fstname">
				<link-navigator-main
					ref="navigator"
					:idGenerator="$lv.$utils.uuid"
					:showPathInUrl="false"
					:afterOpenTab="afterOpenTab"
					:openPreviousAfterInit="false"
					page404="not-found"
					:storageKey="page.storageKey"
					@click-title="lv_clickTitle"
				/>
			</div>
		</div>
	</div>
</template>

<script>
	import DocumentMenu from "./document-menu";

	export default {
		name: "document-home",
		components: {DocumentMenu},
		props: {
			page: {},
		},
		provide() {
			return {
				DocumentPage: this.page
			}
		},
		data() {
			return {
				documentLinks: [
					{label: '前端组件文档', url: 'http://dev.linkcrm.cn/frontdoc'},
					{label: '后端文档', url: 'http://dev.linkcrm.cn/crmdoc'},
					{label: '微信小程序文档', url: 'http://dev.linkcrm.cn/mpdoc'},
					{label: 'CDC文档', url: 'http://dev.linkcrm.cn/cdcdoc'},
					{label: '移动文档', url: 'http://dev.linkcrm.cn/appdoc'},
				],
				showDropdown: false,
				showUserDropdown: false,
				user: null,
				fstname: null,
				searchMenuId: null,
				versionList: [
					{version: '1.0.0', id: '100'}
				],
				curVersion: '100',
				searchText: null,
				curMenu: null,
				afterLogin: () => {
					const decodeData = this.$lv.$utils.decodeUrl(window.location.href)
					window.originalHref = window.location.href
					if (!!decodeData.param.id) {
						this.$nextTick(() => this.page.openById(decodeData.param.id, this))
					} else {
						this.$nextTick(() => this.page.openById('home', this))
					}
				}
			}
		},
		created() {
			window.linkToken.logout = () => this.logout()

			const token = this.$lv.$documentLogin.getToken()
			if (!token) {
				this.login()
			} else {
				this.fstname = this.$lv.$documentLogin.getFstName()
				this.afterLogin()
			}

			window.addEventListener('click', this.handleClickWindow, true)

			this.$lv.init()

		  	this.$lv.$documentAccessService.DocPageMenu = this.page
		},
		computed: {
			searchRecommend() {
				return Object.keys(this.page.idMaps).map(key => this.page.idMaps[key])
			},
		},
		methods: {
			/**
			 * 打开一个菜单
			 * @author  韦胜健
			 * @date    2019/9/25 16:27
			 */
			openMenu(menu) {
				if (!!menu.handler) {
					menu.handler.call(this)
				} else {
					this.page.openById(menu.id, this)
				}
				// 统计文档打开情况
				this.$lv.$documentAccessService.openDocEvent(menu, {title: this.page.title, op: 'open'})
			},
			/**
			 * 打开登录对话框
			 * @author  韦胜健
			 * @date    2019/9/25 16:27
			 */
			login() {
				this.$lv.$documentLogin.openLoginDialog((data) => {
					this.fstname = data.user.firstName
					this.$lv.$storage.set('navigator-main', null)
					this.afterLogin()
				})
			},
			/**
			 * 登出
			 * @author  韦胜健
			 * @date    2019/9/25 16:27
			 */
			logout() {
				this.$lv.$documentLogin.logout()
				this.fstname = null
				this.login()
			},
			/**
			 * 打开页签后置事件
			 * @author  韦胜健
			 * @date    2019/9/25 16:27
			 */
			afterOpenTab(tab) {
				if (tab.path === 'document-debug') return
				const decodeData = this.$lv.$utils.decodeUrl(window.location.href)
				window.history.pushState({}, null, this.$lv.$utils.encodeUrl(decodeData.url, {id: tab.id, app: 'doc'}))
				this.curMenu = tab
				document.title = tab.title

				this.$emit('after-open-tab', tab)
			},
			/**
			 * 点击页面事件
			 * @author  韦胜健
			 * @date    2019/9/25 16:27
			 */
			handleClickWindow(e) {
				if (e.target.tagName === 'A') {
					/*未完成*/
					if (!e.target.href) {
						this.page.notComplete(this)
						return
					}
					/*页内锚点*/
					let currentHref = window.location.href
					let hashIndex = currentHref.lastIndexOf('#')
					if (hashIndex > -1) currentHref = currentHref.substring(0, hashIndex)
					if (!!e.target.href && e.target.href.indexOf(currentHref) > -1) {
						return;
					}
					e.stopPropagation()
					e.preventDefault()

					const decodeData = this.$lv.$utils.decodeUrl(e.target.href)
					if (!!decodeData.param.id && decodeData.param.app === 'doc') {
						/*新标签文档打开*/
						this.$nextTick(() => this.page.openById(decodeData.param.id, this))
					} else {
						/*外部网址打开*/
						window.open(e.target.href)
					}
				}
			},
			/**
			 * 搜索打开页面
			 * @author  韦胜健
			 * @date    2019/9/25 16:28
			 */
			async searchChange() {
				await this.$lv.nextTick()
				this.page.openById(this.searchMenuId, this)
			},
			/**
			 * 点击页签标题事件
			 * @author  韦胜健
			 * @date    2019/9/25 16:28
			 */
			lv_clickTitle({page, index}) {
				this.$refs.menu.locate(page)
			},
			/**
			 * 打开其他的文档地址
			 * @author  韦胜健
			 * @date    2020/12/23 17:17
			 */
			openDocument(document) {
				window.open(document.url)
			},
          /**
		   * 打开统计页面
           */
          openDocStaticstics(path) {
            switch (path) {
			  case 'access':
                this.$nav.openTab({
                  id: 'doc-components/page/access-statistics.vue',
                  title: '文档访问统计',
                  path: 'access',
                });
                break;
			  case 'creation':
                this.$nav.openTab({
                  id: 'doc-components/page/creation-statistics.vue',
                  title: '文档创作统计',
                  path: 'creation',
                });
				break;
				case 'my-menu':
					this.$nav.openTab({
					  id: 'doc-components/page/my-menu.vue',
					  title: '我的文档',
					  path: 'my-menu',
					  param: {
                        onlyMyDocFlag: true
					  }
					});
					break;

            }
		  }
		},
		beforeDestroy() {
			window.removeEventListener('click', this.handleClickWindow, true)
		}
	}
</script>

<style lang="scss">
	@include themeify {
		.document-home {
			height: 100%;
			width: 100%;
			position: relative;
			display: flex;
			flex-direction: column;

			$menu-width: 360px;

			.document-header {
				height: 56px;
				background-color: #333D54;
				color: white;
				width: 100%;
				box-sizing: border-box;
				padding: 0 32px;
				display: flex;
				align-items: center;

				.document-header-logo {
					width: $menu-width;
					font-size: 18px;
				}

				.document-header-version {
					width: 200px;

					.link-input input, .link-icon {
						color: white !important;
						font-size: 14px;
					}
				}

				.document-header-user {
					flex: 1;
					display: flex;
					align-items: center;
					justify-content: flex-end;
					padding-left: 32px;
					font-size: 14px;

					& > * {
						margin-left: 8px;
					}

					.link-icon {
						font-size: 24px;
						opacity: 0.6;
					}

					.document-header-user-logout-btn, .document-header-user-login-btn {
						&:hover {
							cursor: pointer;
							text-decoration: underline;
						}
					}

					.document-link-list {
						margin-right: 20px;

						.link-dropdown-reference {
							display: flex;
							align-items: center;
						}
					}

					.document-link-list-reference {
						display: flex;
						align-items: center;
						padding: 6px 0;
						margin-right: 20px;
					}
				}
			}

			.document-body {
				flex: 1;
				display: flex;
				overflow: hidden;

				.document-menu {
					width: $menu-width;
					height: 100%;
					overflow: hidden;
				}

				.document-content {
					flex: 1;
					height: 100%;
					overflow: auto;
				}
			}
		}
	}

	html, body {
		margin: 0;
		padding: 0;
		height: 100%;
		width: 100%;
		background-color: white !important;
	}

	@media print {
		body {
			height: initial;
		}
		.document-header, .document-menu {
			display: none !important;
		}
		.document-home {
			display: block;
		}
		.document-home, .document-body, .document-content {
			height: initial !important;
		}
	}
</style>
